import React, { useState, useRef, useEffect } from 'react';
import { FiGlobe, FiCheck, FiChevronDown } from 'react-icons/fi';
import { getLanguageMeta } from '../../i18n/supportedLanguages';
import './LanguageSwitcher.scss';

function LanguageSwitcher({ languages, current, onChange, compact = false }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const currentMeta = getLanguageMeta(current);

  return (
    <div className={`lang-switcher ${compact ? 'lang-switcher--compact' : ''}`} ref={ref}>
      <button
        type="button"
        className="lang-switcher__trigger"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <FiGlobe />
        <span className="lang-switcher__label">{currentMeta.flag || current?.toUpperCase()}</span>
        <FiChevronDown className="lang-switcher__chevron" />
      </button>
      {open && (
        <ul className="lang-switcher__menu" role="listbox">
          {languages.map((code) => {
            const meta = getLanguageMeta(code);
            const isActive = code === current;
            return (
              <li key={code}>
                <button
                  type="button"
                  className={`lang-switcher__item ${isActive ? 'lang-switcher__item--active' : ''}`}
                  onClick={() => {
                    onChange(code);
                    setOpen(false);
                  }}
                  role="option"
                  aria-selected={isActive}
                >
                  <span className="lang-switcher__item-code">{meta.flag || code.toUpperCase()}</span>
                  <span className="lang-switcher__item-name">{meta.nativeLabel || meta.label}</span>
                  {isActive && <FiCheck className="lang-switcher__item-check" />}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
